import React from 'react';
import LocationTemplate from './LocationTemplate';

const YanceyvlePage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Yanceyville"
      stateName="North Carolina"
      countyName="Caswell"
      zipCodes={["27379"]}
      latitude={36.4032}
      longitude={-79.3342}
      population={2039}
      historicalFact="County seat of Caswell County, named after Bartlett Yancey Jr., early politician and planter."
      nearbyTowns={[
        "Roxboro, NC",
        "Durham, NC",
        "Burlington, NC",
        "Danville, VA",
        "South Boston, VA",
        "Oxford, NC",
        "Henderson, NC",
        "Hillsborough, NC"
      ]}
    />
  );
};

export default YanceyvlePage;